import type { z } from 'zod';

/** Reports a field's first issue against its synchronous schema from a refinement, for a field that only some answers require */
export const addFieldIssue = (context: z.RefinementCtx, path: PropertyKey[], schema: z.ZodType, value: unknown) => {
  const [issue] = schema.safeParse(value).error?.issues ?? [];

  if (issue) context.addIssue({ code: 'custom', path, message: issue.message });
};
